import { render } from "./5.LearnIhubThree.vue?vue&type=template&id=4863c414&scoped=true"
import script from "./5.LearnIhubThree.vue?vue&type=script&lang=js"
export * from "./5.LearnIhubThree.vue?vue&type=script&lang=js"

import "./5.LearnIhubThree.vue?vue&type=style&index=0&id=4863c414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4863c414"]])

export default __exports__